import React, { useEffect } from 'react';
import { historico } from '../../json/historico';
import './historico.css';

// Componente para representar una tarjeta de programa
const ProgramaCard = ({ programa }) => (
  <div className='col-md-4 col-sm-6 col-12'>
    <div className='card_container_historicos'>
      
      {/* Imagen en la parte superior */}
      <p>
      <img 
        src={programa.imagen}  
        className='card_img_top'
      />
      </p>

      <div className='card_nompro'>
        <h5>
          <a href={programa.enlace} rel='noopener noreferrer'>
            <b>{programa.nompro}</b>
          </a>
        </h5>
        <h6>
          {programa.descripcion}{' '}
          <a href={programa.enlace} rel='noopener noreferrer'>
            <b></b>
          </a>
        </h6>
      </div>
      
      <div className='card_elementos'>
        {programa.elementos.map((elem, index) => (
          <p key={index}>
            <a href={elem.url} rel='noopener noreferrer'>
              <strong>{elem.elemento}</strong>
            </a>
          </p>
        ))}
      </div>
    </div>
  </div>
);


// Componente principal para mostrar los programas
const Historico = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
      // Añadir clase para animar las tarjetas cuando la página carga
      const cards = document.querySelectorAll('.card');
      cards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('card-loaded');
        }, index * 100); // Retardo entre la aparición de cada tarjeta
      });
    }, []);
  
    return (
    <>

      <div className='container'> {/* container, container-full-width */}
      
       <div className='row'>
          <div className='col-12'>
            <h3 className='title'>Programas Sociales</h3>
            <hr className='hr-gob' />
          </div>
          {/* Mapea los programas y crea una tarjeta para cada uno */}
          {historico.map((programa, index) => (
            <React.Fragment key={index}>
              <ProgramaCard programa={programa} />
              {/* Agrega una línea separadora cada 3 tarjetas */}
              {(index + 1) % 3 === 0 && <hr className='row-separator' />}
            </React.Fragment>
          ))}
        </div>
      
      </div>
      <div align='center'>
        <h3>
          <a href="/Programas/Historico"></a>
        </h3>
      </div>
    </>
  );
};

export default Historico;

